import * as y from 'yup'

export const EmptyYupSchema = y.object()

export const emptyOnSubmitting =
    <T extends y.ObjectSchema<any>>(schema: T) =>
    (isSubmitting: boolean): T => {
        return isSubmitting ? (EmptyYupSchema as any) : schema
    }
